import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSunblockGlyphSecondary from './svgs/SunblockGlyphSecondary.js';
import SvgSunblockGlyph from './svgs/SunblockGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var sunblockGlyph = (props => useIcon(SvgSunblockGlyph, SvgSunblockGlyphSecondary, props));

export { sunblockGlyph as default };
